var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-router-build-option"},[_c('r-icon',{attrs:{"size":20,"name":"bus-station"}}),_c('r-text',[_vm._v(" "+_vm._s(_vm.label)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }